var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.21872 6.78134C8.71865 6.28142 8.04049 6.00058 7.33339 6.00058C6.62628 6.00058 5.94813 6.28142 5.44805 6.78134L2.78139 9.44801C2.52669 9.694 2.32354 9.98825 2.18378 10.3136C2.04403 10.6389 1.97046 10.9889 1.96739 11.3429C1.96431 11.697 2.03178 12.0482 2.16586 12.3759C2.29994 12.7036 2.49795 13.0013 2.74833 13.2517C2.99871 13.5021 3.29645 13.7001 3.62418 13.8342C3.9519 13.9683 4.30305 14.0358 4.65712 14.0327C5.0112 14.0296 5.36112 13.956 5.68647 13.8163C6.01181 13.6765 6.30606 13.4734 6.55205 13.2187L7.28672 12.4847M6.78139 9.21867C7.28146 9.7186 7.95962 9.99944 8.66672 9.99944C9.37382 9.99944 10.052 9.7186 10.5521 9.21867L13.2187 6.55201C13.7045 6.04907 13.9733 5.37546 13.9672 4.67627C13.9611 3.97708 13.6807 3.30825 13.1862 2.81382C12.6918 2.3194 12.023 2.03895 11.3238 2.03288C10.6246 2.0268 9.95099 2.29559 9.44805 2.78134L8.71472 3.51467",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkOutline);
export default __webpack_public_path__ + "static/media/LinkOutline.eeb1990d4639031117461759640e3732.svg";
export { ForwardRef as ReactComponent };